module.exports = Promise.all([parcelRequire.load("6GakI"), parcelRequire.load("3ILOR"), parcelRequire.load("a3YO4")]).then(() => parcelRequire('kyE7b'));